import { render, staticRenderFns } from "./RepairHistory.vue?vue&type=template&id=10a083ca&scoped=true"
import script from "./RepairHistory.vue?vue&type=script&lang=js"
export * from "./RepairHistory.vue?vue&type=script&lang=js"
import style0 from "./RepairHistory.vue?vue&type=style&index=0&id=10a083ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a083ca",
  null
  
)

export default component.exports